function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  id: "Group_15",
  "data-name": "Group 15",
  transform: "translate(-1148.295 -1244.235)"
}, React.createElement("path", {
  id: "Path_9",
  "data-name": "Path 9",
  d: "M-266.926,746.706A47.344,47.344,0,0,1-314.2,699.4a47.332,47.332,0,0,1,47.279-47.279,47.344,47.344,0,0,1,47.3,47.279A47.356,47.356,0,0,1-266.926,746.706Zm0-86a38.745,38.745,0,0,0-38.7,38.7,38.757,38.757,0,0,0,38.7,38.724A38.768,38.768,0,0,0-228.2,699.4,38.757,38.757,0,0,0-266.926,660.7Z",
  transform: "translate(1462.5 592.11)"
}), React.createElement("path", {
  id: "Path_10",
  "data-name": "Path 10",
  d: "M-271.581,725.082V711.749a4.7,4.7,0,0,1,1.366-3.3l8.621-8.62a11.508,11.508,0,0,0,3.346-8.08,8.676,8.676,0,0,0-8.667-8.667,8.675,8.675,0,0,0-8.666,8.667v4.666h-9.334v-4.666a18.021,18.021,0,0,1,18-18,18.02,18.02,0,0,1,18,18,20.612,20.612,0,0,1-6.08,14.678l-7.253,7.253v11.4Z",
  transform: "translate(1462.5 592.11)"
}));

var SvgHelp = function SvgHelp(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    width: 94.581,
    height: 94.581,
    viewBox: "0 0 94.581 94.581",
    ref: svgRef
  }, props), _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgHelp, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/help.536bd9fc.svg";
export { ForwardRef as ReactComponent };